import { useTranslation } from "react-i18next";

import { FormatCurrencyForDisplay } from "@unified-checkout/design-system";

import { SummaryBox } from "@app/dashboard/components/inner_layout/Cards/SummaryBox";
import { useLangStore } from "@app/dashboard/store/lang";
import { formatValues, NO_VALUE } from "../../../utils";
import styles from "./amount-details.module.scss";


export const AmountDetails = ({
  disputedAmount,
  transactionAmount,
  currency,
  isLoading
}: {
  disputedAmount?: number,
  transactionAmount?: number,
  currency?: string,
  isLoading: boolean
}) => {
  const { t } = useTranslation();
  const { lang } = useLangStore();

  const ITEMS_LIST = isLoading ? [] :
    [
      {
        label: t('innerLayout.disputesPage.disputeDetails.detailsBoxes.amountDetails.fields.transactionAmount'),
        value: typeof transactionAmount === 'number' ?
          formatValues(
            currency as string,
            transactionAmount,
            lang
          ) : NO_VALUE,
      },
      {
        label: { text: <span className={styles["amount-details__label--important"]}>{t('innerLayout.disputesPage.disputeDetails.detailsBoxes.amountDetails.fields.disputedAmount')}</span> } as any,
        value: {
          text: <span className={styles["amount-details__value--important"]}>
            {typeof disputedAmount === 'number' ?
              FormatCurrencyForDisplay(
                formatValues(
                  currency as string,
                  disputedAmount as number,
                  lang
                )
              ) : NO_VALUE}
          </span>
        } as any,
      },
    ];


  return (
    <div className={styles["amount-details"]}>
      <SummaryBox
        title={t('innerLayout.disputesPage.disputeDetails.detailsBoxes.amountDetails.title')}
        width="100%"
        height="fit-content"
        itemsList={ITEMS_LIST}
      />
    </div>
  )
}
